/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'
import { loginResponseV4Schema } from './loginResponseV4Schema'

export const loginResponseV4ApiResponseObjectV4Schema = z
  .object({
    ok: z.boolean().default(false),
    errorMsg: z.string().nullish(),
    redirectAction: z.unknown().nullish(),
    result: loginResponseV4Schema.describe(
      'A token pair plus the full identity object, so the client needs no follow-up `me/getMe`.\r\nFrom `auth/login` on an untrusted browser it instead carries `codeRequired = true` + `pendingToken`\r\n(the email login code step) and the token fields and `user` are null.'
    ),
  })
  .describe(
    'Typed variant of EP.Models.ViewModels.ApiResponseObjectV4, used in `[ProducesResponseType]` so Swagger renders\r\nthe real `result` schema instead of the bare `object` (which the UI shows as `"string"`).\r\nWire shape is identical to the untyped envelope — this only carries the type for the schema generator.'
  )
